import { useAppDispatch, useAppSelector } from "app/hooks"
import { logWater, clearLogWaterSuccess } from "../waterSlice"
import { IDailyWater } from "../waterSlice.types"
import { useFailed, useSuccess } from "features/notification/hooks"

export const useLogWater = (callback?: () => void) => {
  const logWaterLoading = useAppSelector((state) => state.water.logWaterLoading)
  const logWaterSuccess = useAppSelector((state) => state.water.logWaterSuccess)
  const logWaterFailed = useAppSelector((state) => state.water.logWaterFailed)

  const dispatch = useAppDispatch()

  const handleLogWater = (payload: IDailyWater) => {
    dispatch(logWater(payload))
  }

  const handleClearLogWaterSuccess = () => {
    dispatch(clearLogWaterSuccess())
  }

  useFailed(logWaterFailed)
  useSuccess(logWaterSuccess, { message: "" }, () => {
    handleClearLogWaterSuccess()
    callback?.()
  })

  return {
    logWaterLoading,
    handleLogWater,
  }
}
